import {
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN,
} from '../constants';

export function hasReEnteredVehicle(id) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN,
            data: id
        })
    }
}

